// extracted by mini-css-extract-plugin
module.exports = {"search_bar":"SearchBar_search_bar__2bFNn","button":"SearchBar_button__3s_hP"};